import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { getDefaultRequestHeaderParams } from '../../../utils/getRequestHeaderParams';
import { getChatApiBaseUrl } from '../../../utils/getChatApiBaseUrl';
import { getCustomerTrackingId } from '../../../utils/getAdobeCustomerTrackingId';

@Injectable({
  providedIn: 'root',
})
export class GenesysDxApiService {
  constructor(private http: HttpClient) {}

  createLiveChat({
    departmentId = '',
    platform = '',
    firstName = '',
    lastName = '',
    language = 'en',
    sessionId = '',
  }): Observable<any> {
    const name = firstName + ' ' + lastName;
    const formData = {
      name,
      custom_custtrackingid: getCustomerTrackingId(),
    };
    return this.http.post(
      getChatApiBaseUrl() + '/ucx-livechat/livechat',
      formData,
      {
        headers: {
          ...getDefaultRequestHeaderParams({
            platform,
            language,
            'session-identifier': sessionId,
            'department-id': departmentId,
            'chat-url': document.location.href,
            'Content-Type': 'application/json',
          }),
        },
        withCredentials: true,
      }
    );
  }

  startLiveChatClient({
    platform = '',
    departmentId = '',
    sessionId = '',
    chatKey = '',
  }): Observable<any> {
    return this.http.put(
      getChatApiBaseUrl() + '/ucx-livechat/livechat',
      {},
      {
        headers: {
          ...getDefaultRequestHeaderParams({
            platform,
            'session-identifier': sessionId,
            'Content-Type': 'application/json',
            'department-id': departmentId,
            'chat-key': chatKey,
          }),
        },
        withCredentials: true,
      }
    );
  }

  finishChat({
    departmentId = '',
    platform = '',
    chatKey = '',
    clientId = '',
    sessionId = '',
  }): Observable<any> {
    return this.http.delete(getChatApiBaseUrl() + '/ucx-livechat/livechat', {
      headers: {
        ...getDefaultRequestHeaderParams({
          platform,
          'session-identifier': sessionId,
          'department-id': departmentId,
          'client-id': clientId,
          'chat-key': chatKey,
        }),
      },
      withCredentials: true,
    });
  }
}
